<script setup lang="ts">
import { baseUrl } from '@/utils/helpers'
import BasePresentation from '../base/BasePresentation.vue'

interface Props {
  desktop?: string
  mobile?: string
}

const props = withDefaults(defineProps<Props>(), {
  desktop: '',
  mobile: '',
})

const srcM = baseUrl('/videos/' + props.mobile)
const srcD = baseUrl('/videos/' + props.desktop)
</script>

<template>
  <BasePresentation>
    <div v-if="mobile || desktop" class="fixed inset-0 -z-10">
      <video
        v-if="mobile"
        :src="srcM"
        class="block sm:hidden absolute w-full h-full object-cover"
        autoplay
        loop
        muted
        playsinline
      ></video>
      <video
        v-if="desktop"
        :src="srcD"
        class="hidden sm:block absolute w-full h-full object-cover"
        autoplay
        loop
        muted
        playsinline
      ></video>
    </div>

    <slot></slot>
  </BasePresentation>
</template>
